import {
  findCurrentAgencies,
  findCurrentBatchLabel,
} from "../report/reportActions";

export const transformDealerBillingInput = (values, taskKey) => (state) => {
  const agency = findCurrentAgencies(state, values.AgencyKeys);
  const batchFromLabel = findCurrentBatchLabel(state, values.BatchNumberFrom);
  const batchToLabel = findCurrentBatchLabel(state, values.BatchNumberTo);
  const transactionDates = [
    values.TransactionDate[0],
    values.TransactionDate[1],
  ];
  return {
    ...values,
    AgencyNameAndNumber: agency.FullName,
    ProducersTaskKey: taskKey,
    BatchFromLabel: batchFromLabel,
    BatchToLabel: batchToLabel,
    TransactionDate: transactionDates,
    FileName: `DealerBilling${values.ReportType}_${agency.Number}`,
  };
};
